<script>
    export let action_id;
    export let action_items;
</script>


<div class="actionholder">
    {#each action_items as ai}
        <div
            class="iconholder"
            on:mouseup={(e) => {
                if (e.button === 1 && ai.middle_click_link) { ai.middle_click_link(action_id); } 
            }}
        >
            {#if ai.l !== undefined}
                <a href="{ai.l.replaceAll('<action_id>', action_id)}"><i class="{ai.i}" style="{ai.s}"></i></a>
            {:else}
                <i class="{ai.i}" style="{ai.s}" on:click={()=>{ai.f(action_id);}}></i>                
            {/if}
        </div>
    {/each}
</div>


<style>
    .actionholder {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
    }
    .actionholder i {
        cursor: pointer;
    }
    .iconholder {
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

</style>